import captureException from 'src/common/utils/captureException';
import { SimpleQuestion } from 'src/common/types/common/SimpleQuestion';

const verifyFaqs = (faqs: SimpleQuestion[], url: string): SimpleQuestion[] => {
  let faqFormatVerified = true;

  const filteredFaqs = (faqs.filter((faq) => {
    if (!faq.question || !faq.answer) {
      faqFormatVerified = false;
      return false;
    }
    return true;
  }));

  if (!faqFormatVerified && typeof window !== 'undefined') {
    captureException(
      new Error('FAQ data was malformed'),
      {
        extra: {
          faqs: {
            ...faqs,
          },
          url,
        },
      },
    );
  }

  return filteredFaqs;
};

export default verifyFaqs;
